<template>
  <span class="red">*</span>
</template>

<script>
export default {};
</script>

<style scoped>
.red {
  color: red;
}
</style>
